/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloPisos from 'Infotrack@Modelos/smartStock/pisos';
import IPisos from 'Infotrack@Modelos/smartStock/pisos/entidades/pisos';

export default class ControladorModeloPisos {
    private modeloPisos: ModeloPisos;
    constructor() {
        this.modeloPisos = new ModeloPisos();
    }

    public consultarPisos() {
        return this.modeloPisos.consultarPisos().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearPisos(pisos: IPisos) {
        await this.modeloPisos.crearPisos(pisos);
    }

    public async editarPisos(pisos: IPisos) {
        await this.modeloPisos.editarPisos(pisos);
    }
    public async eliminarPisos(pisos: IPisos) {
        await this.modeloPisos.eliminarPisos(pisos);
    }

    public validarEntidad(pisos: IPisos): boolean {
        if (pisos.DescripcionPiso === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);  
            return false;
        }
        return true;
    }

    public async consultarPisosPorFiltro(pisos: Partial<IPisos>) {
       return  (await this.modeloPisos.consultarListaPisosPorFiltro(pisos)).data.Entidades;
    }
}
